import { ApiError } from '@cmr/react-api-hook';
import { ActionType, createAction, createAsyncAction } from 'typesafe-actions';
import { Dataset, DatasetRecordChanges } from './types';

export const actions = {
  fetchAvailable: createAsyncAction(
    'fetchAvailable/request',
    'fetchAvailable/success',
    'fetchAvailable/failure',
  )<undefined, Partial<Dataset>[], ApiError>(),
  fetch: createAsyncAction('fetch/request', 'fetch/success', 'fetch/failure')<
    string,
    [Dataset, string],
    [ApiError, string]
  >(),
  datasetRecordChanges: createAction(
    'signalR/DatasetRecordChanges',
  )<DatasetRecordChanges>(),
  add: createAction('add')<Partial<Dataset>>(),
};

export default actions;

export type DatasetAction = ActionType<typeof actions>;
